export const passkeysFaqItems = [
  {
    title: 'Are passkeys the replacement for passwords?',
    body: (
      <div className="pr-4 font-medium text-md ">
        <p>
          Passkeys are a replacement for your password. With passkeys, you can sign into your USCIS online account using
          your face, fingerprint, or PIN. Signing in with a passkey is simple, fast, and helps protect you against
          phishing attacks.
        </p>
        <br></br>
        <p>Passkeys are supported on desktop and mobile browsers.</p>
      </div>
    ),
  },
  {
    title: 'How does authentication with passkeys work?',
    body: (
      <div className="pr-4 font-medium text-md ">
        <p>
          Instead of sending a password over the internet, your device generates a pair of corresponding keys: a private key and a public key.
        </p>
        <br />
        <ul className="list-disc px-8 font-medium text-md ">
          <li className="pb-2">The private key is stored securely on your device</li>
          <li className="pb-2">The public key is registered with the website or application</li>
        </ul>
        <br />
        <p>
          A secure passkey is created by a series of events. First, you successfully sign in, then the website or application creates a unique, one-time public key to confirm the login attempt is happening in real time. The public key is used to verify the association of your fingerprint, face scan, or previously provided passcode to the current, successful, real-time, log-in event.  Finally, your device permanently associates the public key with your selected authentication method (fingerprint, face scan, or passcode) and encrypts it, which creates a digital authorization to validate the login request was approved by you and originated from your trusted device.
        </p>
        <br />
        <p>
          Your private key and authentication method never leave your trusted device. They stay encrypted and protected, ensuring your login remains accessible and secure while your personal information stays private.
        </p>
      </div>
    ),
  },
  {
    title: 'Are passkeys considered approved multi-factor authentication?',
    body: (
      <div className="pr-4 font-medium text-md ">
        Yes, passkeys are considered a form of multi-factor authentication. When you use a passkey, you must use a device that stores the passkey (something you have) and unlock the desired website or application with the associated biographic information or a PIN (something you are, or something you know). Using these multiple factors to access the website or application enhance your online security and protect your information.
      </div>
    ),
  },
  {
    title: 'Are passkeys phishing resistant?',
    body: (
      <div className="pr-4 font-medium text-md ">
        Yes, passkeys are phishing resistant. When they are created, passkeys are associated with the specific domain that the website or app are registered with. A passkey created for your USCIS online account can only be used with your USCIS online account. While a user can be tricked into landing on a similar looking website, they can't present their passkey to the malicious website. Their device won't allow it.
      </div>
    ),
  },
  {
    title: 'Can I use passkeys across multiple devices?',
    body: (
      <div className="pr-4 font-medium text-md ">
        <p>
          Yes, you can use the same passkey on different devices— like your phone, tablet, or computer by using the cross-device authentication process.
        </p>
        <br />

        <p>For example, if your mobile phone is the trusted device where your private key is securely stored, but you are signing in using a different device, select the passkey login option on the website or
           application from the different device— like a laptop. This choice signals to the website or application that you will use login credentials and authenticate using your private key from your phone.  
           A <button aria-describedby="tooltip" className="qr-code-tooltip text-dhs-blue hover:underline">
            QR code
            <p id="tooltip" role="tooltip" className="tooltiptext bg-dhs-blue-03 text-white">
              A QR code stores URLs and other information in a series of black and white squares that are read by your smart phone and camera. 
            </p>
            <span className="tooltip-tail"></span>
            </button>  will appear on the laptop to scan with your phone. This process securely links the two devices, allows your phone to complete the log-in process and verify your authentication method without 
           ever sharing your private key to another device.   
        </p>
        <br />
        <p>
          Your private key and biometric data never leave your trusted device, which keeps your login credentials secure and private.
        </p>
      </div>
    ),
  },
];
